import { PrismicRichText } from 'prismic/types/richtext';
import { FormSlicesCheckbox_Input } from 'prismic-types';
import slugify from 'slugify';

import { Check } from 'components/form-elements/Check';
import { asText, RichText } from 'components/rich-text/RichText';
import { checkBoxLiteralValue } from 'containers/forms/Validation';

type Props = {
  text: PrismicRichText;
  name: PrismicRichText;
  required?: boolean;
  defaultChecked?: boolean;
};

export const CheckboxSlice = ({ name, text, required }: Props) => {
  return (
    <Check
      label={<RichText>{text}</RichText>}
      required={required}
      value={checkBoxLiteralValue}
      name={slugify(asText(name))}
    />
  );
};

export const MailinglistCheckboxSlice = ({ name, text, required }: Props) => {
  return (
    <Check
      label={<RichText>{text}</RichText>}
      required={required}
      value={checkBoxLiteralValue}
      name={slugify(asText(name))}
    />
  );
};

export const prismicSliceToCheckboxInput = (s: FormSlicesCheckbox_Input) => {
  const primary = s.variation?.primary;
  if (!primary) {
    return null;
  }

  const name = (primary.name ?? null) as PrismicRichText;
  const text = (primary.text ?? null) as PrismicRichText;
  const isMailingList = !('required' in primary);
  const defaultChecked = primary.defaultChecked as boolean;

  if (isMailingList) {
    return (
      <MailinglistCheckboxSlice name={name} text={text} defaultChecked={defaultChecked} />
    );
  } else {
    const required = primary.required as boolean;
    return (
      <CheckboxSlice
        name={name}
        text={text}
        required={required}
        defaultChecked={defaultChecked}
      />
    );
  }
};
